// Compression/redimensionnement d'image côté client avant upload.
// Réduit les photos volumineuses (téléphone) pour fiabiliser l'upload et l'analyse IA.
// Renvoie un File (JPEG) ; en cas d'échec, renvoie le fichier d'origine.
export async function compressImage(file, maxDim = 1600, quality = 0.82) {
  try {
    if (!file || !file.type || !file.type.startsWith("image/")) return file;
    // Pas la peine de compresser les petits fichiers (< 900 Ko)
    if (file.size && file.size < 900 * 1024) return file;

    const dataUrl = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });

    const img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = dataUrl;
    });

    let { width, height } = img;
    if (width > maxDim || height > maxDim) {
      const ratio = Math.min(maxDim / width, maxDim / height);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    if (!blob) return file;
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch (_) {
    return file;
  }
}
